import { useEffect } from 'react';

import { useErrorHandler } from '@futrli/errors';

import { useLogout } from '../hooks/useLogout';

export const Logout = () => {
  const handleError = useErrorHandler();
  const { logout } = useLogout();

  useEffect(() => {
    try {
      logout();
    } catch (e) {
      handleError(e);
    }
  }, [handleError, logout]);

  return null;
};
